import { StateService } from "@uirouter/angularjs";
import { IOnInit } from "angular";
import { FormViewController } from "../../../../app/records/forms/formView/controller";
import { ContractConfiguration } from "../../shared/models/contractConfiguration";
import fieldHelpers from "../../../../app/ui-formly/fieldHelpers";
import {
  ContractService,
  vsServiceName as ContractServiceName,
  ContractTypeService,
  IContractTab,
  IContractType,
} from "../../shared/ContractService";

interface Contract {}

interface IContractConfig {}

export class ContractDetailsViewController implements IOnInit {
  readonly contract!: Contract;
  readonly contractType!: ContractTypeService;

  constructor() {}

  $onInit(): void {}

  getTabs() {
    return this.contractType.tabs ?? [];
  }

  getTabSref(tab: IContractTab) {
    return this.contractType.infoSref(tab);
  }
}
